<template>
  <label class="form-checkbox-field">
    <input
      type="checkbox"
      v-model="local"
      :true-value="trueValue"
      :false-value="falseValue"
      @change="onChange"
    >
    <span class="form-checkbox__indicator">
      <svg
        viewBox="0 0 14 11"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 5.191l5.128 4.232L12.326 1"
          style="fill: none; fill-rule: evenodd; stroke: rgb(224, 224, 224); stroke-width: 1;"
        ></path>
      </svg>
    </span>
    <span class="form-checkbox__description ml--16px">{{label}}</span>
  </label>
</template>

<script>
export default {
  props: {
    value: { type: [String, Boolean], required: true },
    label: { type: String, default: '' },
    trueValue: { type: [String, Boolean], default: true },
    falseValue: { type: [String, Boolean], default: false }
  },
  data () {
    return {
      local: this.value
    }
  },
  watch: {
    value () {
      this.local = this.value
    }
  },
  methods: {
    onChange ($event) {
      this.$emit('change', this.local)
      this.$emit('input', this.local)
      // this.$emit('change', $event.target.checked)
      // this.$emit('input', $event.target.checked)
    }
  }

}
</script>
